import HomeChatting from "../components/Home/HomeChatting/HomeChatting";
import HomeRooms from "../components/Home/HomeRooms/HomeRooms";
import HomeMembers from "../components/Home/HomeMembers/HomeMembers";
import HomeNotice from "../components/Home/HomeNotice/HomeNotice";
import HomeHeader from "../components/Home/HomeHeader";
import { useRecoilState } from "recoil";
import homeState from "../atoms/home";
import { useEffect } from "react";
import emitGetUsers from "../connector/emits/getUsers";
import emitGetMessages from "../connector/emits/getMessages";
import emitGetMyInfo from "../connector/emits/getMyInfo";
import roomDetailState from "../atoms/roomDetail";
import { userBoxState } from "../atoms/common";
import { getRecoil, setRecoil } from "recoil-nexus";
import emitFreezeUser from "../connector/emits/freezeUser";
import emitGetRoomDetail from "../connector/emits/getRoomDetail";
import emitGetIsKick from "../connector/emits/getIsKick";
import myInfoState from "../atoms/myinfo";
import emitAppointManager from "../connector/emits/appointManager";
import emitDisappointManager from "../connector/emits/disappointManager";

const getParentByClass = (el: any, className: string) => {
  do {
    if (el.classList.contains(className)) {
      return el;
    } else {
      el = el.parentNode;
    }
  } while (el && el.parentNode)
}

function Home() {
  const [home] = useRecoilState(homeState);
  const [roomDetail, setRoomDetail] = useRecoilState(roomDetailState);
  const [userBox] = useRecoilState(userBoxState);
  const [myInfo] = useRecoilState(myInfoState);

  useEffect(() => {
    emitGetMyInfo();
    emitGetUsers('square');
    emitGetMessages('square');
    roomDetail.id = 'square';
    setRoomDetail(roomDetail);

    setInterval(() => {
      emitGetRoomDetail('square');
      emitGetIsKick('square');
    }, 1000);

    const clickEvent = (e: MouseEvent) => {
      const el = e.target;
      const found1 = getParentByClass(el, 'user-box');
      const found2 = getParentByClass(el, 'no-close-user-box');
      if (found1 || found2) {
        // No action
      } else {
        const newUserBox = { ...getRecoil(userBoxState) };
        newUserBox.display = false;
        setRecoil(userBoxState, newUserBox);
      }
    };

    // eslint-disable-next-line no-restricted-globals
    addEventListener('click', clickEvent);
    return () => {
      // eslint-disable-next-line no-restricted-globals
      removeEventListener('click', clickEvent);
    }
  }, []);

  const closeUserBox = () => {
    const newUserBox = { ...getRecoil(userBoxState) };
    newUserBox.display = false;
    setRecoil(userBoxState, newUserBox);
  }

  const runFreeze = () => {
    emitFreezeUser(userBox.userId);
    closeUserBox();
  };

  const appointManager = () => {
    emitAppointManager(userBox.userId);
    closeUserBox();
  };

  const disappointManager = () => {
    emitDisappointManager(userBox.userId);
    closeUserBox();
  };

  return (
    <div>
      <HomeHeader />
      {
        {
          'chatting': <HomeChatting />,
          'rooms': <HomeRooms />,
          'members': <HomeMembers />,
          'notice': <HomeNotice />,
        }[home.menu]
      }

      <div style={{
        backgroundColor: 'white',
        width: 130,
        position: 'fixed',
        top: userBox.y,
        left: userBox.x,
        display: (
          userBox.display && userBox.userId !== myInfo.id && myInfo.id
          ) ? 'block' : 'none',
      }} className='user-box'>
        <div style={{
          background: '#414141',
          color: 'white',
          padding: 5,
        }}>{userBox.userName}</div>
        {
          (myInfo.id === 'admin' || roomDetail.owner === myInfo.id || roomDetail.managers.includes(myInfo.id)) &&
          !((roomDetail.managers.includes(myInfo.id) && roomDetail.managers.includes(userBox.userId)) || userBox.userId === 'admin')
          ? (
            <>
              <div style={{
                cursor: 'pointer',
                background: '#d9d9d9',
                padding: 5,
              }} onClick={runFreeze}>벙어리</div>
              {myInfo.id === 'admin' ? (
                !roomDetail.managers.includes(userBox.userId) ? (
                  <div style={{
                    cursor: 'pointer',
                    background: '#d9d9d9',
                    padding: 5,
                  }} onClick={appointManager}>매니저 임명</div>
                ) : (
                  <div style={{
                    cursor: 'pointer',
                    background: '#d9d9d9',
                    padding: 5,
                  }} onClick={disappointManager}>매니저 해제</div>
                )
              ) : null}
            </>
          )
          : null
        }
        <div style={{
          cursor: 'pointer',
          background: '#d9d9d9',
          padding: 5,
        }} onClick={() => {
          window.open(`/chat-one-on-one/?partner=${userBox.userId}`, "_blank", "width=440,height=496");
        }}>1:1 채팅</div>
      </div>

    </div>
  );
}

export default Home;
